export const Noise = () => {
  return <div className="noise-overlay" data-testid="noise-overlay" aria-hidden="true" />;
};
